














import Vue from 'vue';

export default Vue.extend({
  name: 'NameAllowed',
  methods: {
    goToModels() {
      this.$router.push({
        name: 'Models'
      });
    }
  }
});
